import { render } from "./hanukaRamatDavid23.vue?vue&type=template&id=5ab0f42e&scoped=true"
import script from "./hanukaRamatDavid23.vue?vue&type=script&lang=js"
export * from "./hanukaRamatDavid23.vue?vue&type=script&lang=js"

import "./hanukaRamatDavid23.vue?vue&type=style&index=0&id=5ab0f42e&scoped=true&lang=css"

import exportComponent from "/media/rafa/mainDisk/Documents/Raphael/Development/NavigationApplication/efoani/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ab0f42e"]])

export default __exports__